module.exports = __webpack_public_path__ + "img/BIT_white11.60d41387.jpg";